import React, { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { canAccessRoute, getDefaultRouteForRole } from '../../config/roles';
import SignInPage from './SignInPage';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { currentUser } = useAuth();
  const location = useLocation();

  if (!currentUser) {
    return <SignInPage />;
  }

  const role = currentUser.role || 'finance';
  const pathname = location.pathname;
  const searchParams = new URLSearchParams(location.search || '');

  if (!canAccessRoute(role, pathname, searchParams)) {
    return <Navigate to={getDefaultRouteForRole(role)} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
